import { EntityModel } from '../model';
import { UserRoleModel } from '../users/user-role.model';

export abstract class BaseAclModel extends EntityModel {
    public UserId: number = null;
    public UserGuid: string = null;
    public UserRole: UserRoleModel = new UserRoleModel();
}
